// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from 'firebase/auth'


const firebaseConfig = {
  apiKey: "AIzaSyB36nDl-q2Tsx1Ix9APQte4ZL9x3AVRbmg",
  authDomain: "moviecorn-cf595.firebaseapp.com",
  projectId: "moviecorn-cf595",
  storageBucket: "moviecorn-cf595.appspot.com",
  messagingSenderId: "364561527504",
  appId: "1:364561527504:web:e10221c9c56262dfea24d5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);


